import React, { useEffect, useState } from 'react';
import { Button, Dialog, IconButton, makeStyles, Paper,TextField } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import './userForm.css';
import {useDispatch} from 'react-redux'
import validator from 'validator';


const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        maxHeight: '80vh',
        maxWidth: '30vw',
        minWidth: '30vw'
    }
}));

export default function PaymentForm(props) {
    const dispatch = useDispatch()
    const { open, handleClose,userCardData ,currentUserId} = props;
    const classes = useStyles()
    const [cardNumber, setCardNumber] = useState('');
    const [updateNumber, setUpdateNumber] = useState(false);
    const [expiryYear, setExpiryYear] = useState('');
    const [expiryMonth, setExpiryMonth] = useState('');
    const [cvv, setcvv] = useState('');
    const [cardError, setCardError] = useState('');
    const [monthError, setMonthError] = useState('');
    const [yearError, setYearError] = useState('');
    const [cvvError, setcvvError] = useState('');
    const [isRefreshed, setIsRefreshed] = useState(false);


    const onChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        name == 'cardNumber' && setCardNumber(value)
        name == 'cardNumber' && setUpdateNumber(true)
        name == 'expiryYear' && setExpiryYear(value)
        name == 'expiryMonth' && setExpiryMonth(value)
        name == 'cvv' && setcvv(value)
    }

    const submitHandler = () => {
        
        let currentYear= (new Date()).getFullYear()
            if(!validator.isCreditCard(cardNumber) && updateNumber) {
                setCardError("Card Number is not valid");
                return
              } 
            if(Number(expiryMonth)<0 || Number(expiryMonth)>12) {
                setMonthError("Month is not valid");
                return
              } 
            if(Number(expiryYear)<currentYear &&  Number(expiryMonth)>9999) {
                setYearError("Year is not valid");
                return
              } 
            if(cvv.length!=3) {
                setcvvError("Cvv is not valid");
                return
              } 
        
        
        handleClose()
    }

    const cancelHandler = () => {
        handleClose()
        setIsRefreshed(!isRefreshed)
    }

    useEffect(() => {
        if( userCardData && userCardData.card_number){
            
            setExpiryMonth(userCardData.expiry_date)
            setExpiryYear(userCardData.expiry_year)
        }
  },[userCardData,isRefreshed])
   
    return (
        <Dialog
            maxWidth={100}
            open={open}
            onClose={cancelHandler}
            classes={{ paper: classes.dialogPaper }}
        >
            <Paper className="addUser">
                <div className="userHeader">
                    <h4>Card details</h4>
                    <IconButton onClick={cancelHandler}>
                        <Clear />
                    </IconButton>
                </div>
                <form>
                    <div className="formBody">
                        <div className="formGroup">
                            <label>Card Number</label>
                            <input
                                type="text"
                                placeholder="Enter your card number"
                                name="cardNumber"
                                value={cardNumber}
                                onChange={onChange}
                            />
                            <span style={{color: "red"}}>{cardError}</span>
                        </div>
                        <div className="formGroup">
                            <label>Expiry Month</label>
                            <input
                                type="text"
                                placeholder="Enter expiry Month"
                                value={expiryMonth}
                                name="expiryMonth"
                                onChange={onChange}
                            />
                          <span style={{color: "red"}}>{monthError}</span>
                        </div>
                        <div className="formGroup">
                            <label>Expiry Year</label>
                            <div>
                              <input
                                placeholder="Enter expiry year"
                                type="text"
                                name="expiryYear"
                                value={expiryYear}
                                onChange={onChange}
                                />
                            <span style={{color: "red"}}>{yearError}</span>
                            </div>
                        </div>
                        <div className="formGroup">
                            <label>CVV</label>
                            <div>
                              <input
                                placeholder="Enter cvv"
                                type="password"
                                name="cvv"
                                value={cvv}
                                onChange={onChange}
                                />
                            <span style={{color: "red"}}>{cvvError}</span>
                            </div>
                        </div>
                    </div>
                    <div className="formFooter">
                        <Button className="btn-yellow" onClick={submitHandler}>Make Payment</Button>
                        <Button className="btn-yellow" onClick={cancelHandler}>Cancel</Button>
                    </div>
                </form>
            </Paper>
        </Dialog>
    )
}
